const getSelectedUsersString = (users) => users.map((user) => user.name).join(', ')

export default getSelectedUsersString
